import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/fund/icon_exclamation_mark.png'


const _withScopeId = n => (_pushScopeId("data-v-4968ed19"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "paypal-timeout"
}
const _hoisted_2 = { class: "paypal-timeout-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paypal-timeout-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_4 = { class: "paypal-timeout-title" }
const _hoisted_5 = { class: "paypal-timeout-text" }
const _hoisted_6 = { class: "paypal-timeout-btn" }


import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  props: ['visible'],
  emits: ['update:visible', 'submit'],
  setup(__props, { emit }) {

const props = __props


const cancel = () => {
  emit('update:visible', false)
}

return (_ctx: any,_cache: any) => {
  return (__props.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('请求超时，请稍后重试')), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('由PayPal提供服务')), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "paypal-timeout-cancel",
              onClick: cancel
            }, _toDisplayString(_unref(t)('关闭')), 1),
            _createElementVNode("div", {
              class: "paypal-timeout-ok",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('submit')))
            }, _toDisplayString(_unref(t)('再试一次')), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})